import { useEffect, useState } from 'react';

export interface UsePlatformShortcutLabelOptions {
  macLabel?: string;
  otherLabel?: string;
}

interface UsePlatformShortcutLabelResult extends Pick<UsePlatformShortcutLabelOptions, 'macLabel' | 'otherLabel'> {
  showShortcut: boolean;
  label: string;
}

export function usePlatformShortcutLabel(options?: UsePlatformShortcutLabelOptions): UsePlatformShortcutLabelResult {
  const { macLabel = '⌘K', otherLabel = 'Ctrl K' } = options ?? {};

  const [showShortcut, setShowShortcut] = useState(false);
  const [label, setLabel] = useState(macLabel);

  useEffect(() => {
    if (typeof window === 'undefined') {
      return;
    }

    const isTouchDevice = 'ontouchstart' in window || (typeof navigator !== 'undefined' && (navigator.maxTouchPoints ?? 0) > 0);

    if (isTouchDevice) {
      setShowShortcut(false);
      return;
    }

    const userAgent = navigator.userAgent.toLowerCase();
    const isApplePlatform = userAgent.includes('mac os x') || userAgent.includes('iphone') || userAgent.includes('ipad') || userAgent.includes('ipod');

    setLabel(isApplePlatform ? macLabel : otherLabel);
    setShowShortcut(true);
  }, [macLabel, otherLabel]);

  return { showShortcut, label, macLabel, otherLabel };
}
